module.exports = __webpack_public_path__ + "img/4b58988fcc_21751a944a.1a7b0f58.webp";